import { useContext, useEffect, useState } from 'react';
import AccountPickerContext from '../../../../../../contexts/AccountPickerContext';
import STORE from '../../../../../../store';
import PerformanceWizardContext from '../PerformanceWizardContext';

const useFixedIntervalOptions = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { setWizardState, wizardState } = useContext(PerformanceWizardContext);
  const [options, setOptions] = useState<DropdownOption[]>([]);

  useEffect(() => {
    let isActive = true;
    STORE.fixedPeriods
      .getFixedPeriodSchemesRef({ accountId: selectedAccountId })
      .get()
      .then((schemes) => {
        if (!isActive) {
          return;
        }

        const newOptions: DropdownOption[] = [];
        schemes.forEach((s) => {
          const scheme = s.data();
          newOptions.push({
            key: scheme.id,
            label: scheme.name,
            isSelected:
              wizardState.config.datasetStep.fixedPeriod === scheme.id,
            onSelected: () => {
              setWizardState((current) => {
                return {
                  ...current,
                  config: {
                    ...current.config,
                    datasetStep: {
                      ...current.config.datasetStep,
                      fixedPeriod: scheme.id,
                    },
                  },
                };
              });
            },
          });
        });
        setOptions(newOptions);
      });

    return () => {
      isActive = false;
    };
  }, [
    selectedAccountId,
    setWizardState,
    wizardState.config.datasetStep.fixedPeriod,
  ]);

  return options;
};

export default useFixedIntervalOptions;
